export const contacts = {
  phone: '(951) 463-5259',
  email: 'smart.people.move@gmail.com',
  address: '9909 Hibert St, Unit D, San Diego, CA 92131',
  address2: '6530 Reflection Dr,Unit 2386, San Diego, CA 92124',
  address3: '30650 Rancho California Rd, Suite D406 #372, Temecula, CA 92591',
};
